import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {AuthService} from '@services/api/auth/auth.service';
import {SharedDataService} from '@services/share-data/share-data.service';
import { Subject, takeUntil } from 'rxjs';
import {emailFormatValidator} from '@core/shared/form-validators';
import {MaterialModule} from '@app/material.module';

@Component({
  selector: 'app-recovery-password',
  imports: [RouterModule, MaterialModule, TranslateModule, CommonModule, ReactiveFormsModule],
  standalone: true,
  templateUrl: './recovery-password.component.html',
  styleUrl: './recovery-password.component.scss'
})
export class RecoveryPasswordComponent {
  password_reset_form: FormGroup;
  private destroy$ = new Subject<void>();
  private auth_service = inject(AuthService);
  private share_data_service = inject(SharedDataService);
  private router = inject(Router);

  constructor(private fb: FormBuilder) {
    this.router = new Router();
    this.password_reset_form = this.fb.group({
      email: ['', [Validators.required, Validators.email, emailFormatValidator]]
    });
  }

  onSubmit(): void {
    if (this.password_reset_form.valid) {
      this.auth_service
        .request_reset_password(
          this.password_reset_form.get('email')?.value
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            const email = this.password_reset_form.get('email')?.value;
            this.share_data_service.setData(email);
            this.router.navigate(['/recovery-password-confirm']);
          },
          error: (error) => {
            this.password_reset_form.reset();
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get emailFormControl() {
    return this.password_reset_form.get('email');
  }
}
